module.exports = __webpack_public_path__ + "static/media/golfer-4-b.d0b76f56.png";